import { render, staticRenderFns } from "./MedicineInformation.vue?vue&type=template&id=e5ccc5e4&scoped=true&"
import script from "./MedicineInformation.vue?vue&type=script&lang=ts&"
export * from "./MedicineInformation.vue?vue&type=script&lang=ts&"
import style0 from "./MedicineInformation.vue?vue&type=style&index=0&id=e5ccc5e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ccc5e4",
  null
  
)

export default component.exports